import { ReportFormStepper } from "Components/AddEditReport";

export const AddEditReport = () => {
  return (
    <div className="flex flex-col items-center justify-start w-full ">
      <ReportFormStepper />
    </div>
  );
};
